"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.verifyMessage = exports.signMessage = exports.logConnectEvent = exports.createWebExtensionLink = void 0;

var _helpers = require("@nettoken/helpers");

var _constants = require("./constants");

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var state = {
  decryptEvent: '',
  encryptEvent: '',
  logger: {
    enabled: false,
    plaintext: false
  },
  target: null,
  worker: null
};
/**
 * @param {object} nextState
 */

var setState = function setState(nextState) {
  state = _objectSpread({}, state, nextState);
};

var SRC_EXT = 'extension';
var SRC_WEB = 'web';
var VALID_TARGETS = [SRC_EXT, SRC_WEB];
var PLAINTEXT_EVENTS = [_constants.WEL_HANDSHAKE, _constants.WEL_QR_AUTH, _constants.WEL_STATUS];

var checkDuplicateInit = function checkDuplicateInit() {
  try {
    checkLinkExists();
    throw new Error('duplicate');
  } catch (e) {
    if (e.message === 'duplicate') {
      throw new Error('Duplicate `createWebExtensionLink()` call!');
    }
  }
};

var checkLinkExists = function checkLinkExists() {
  checkValidTarget();

  if (!state.worker || !state.encryptEvent || !state.decryptEvent) {
    throw new Error('You must run `createWebExtensionLink()` first.');
  }
};

var checkValidTarget = function checkValidTarget() {
  if (!VALID_TARGETS.includes(state.target)) {
    throw new Error("Invalid target: ".concat(state.target, ". Must be one of ").concat(JSON.stringify(VALID_TARGETS)));
  }
};
/**
 * @param {object|boolean} options
 *
 * @returns {object}
 */


var constructLoggerOptions = function constructLoggerOptions(options) {
  var logger = _objectSpread({}, state.logger);

  if (options !== undefined) {
    if (_typeof(options) === 'object') {
      logger.enabled = !!options.enabled;
      logger.plaintext = !!options.plaintext;
    } else if (typeof options === 'boolean') {
      logger.enabled = options;
    }
  }

  return logger;
};
/**
 * Decrypt payload received from web app or extension.
 *
 * @param {string} encrypted Base64 encrypted payload.
 *
 * @returns {object}
 */


var decryptPayload =
/*#__PURE__*/
function () {
  var _ref = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee(encrypted) {
    var event, _ref2, message, payload;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            checkLinkExists();
            event = state.decryptEvent;
            _context.next = 4;
            return state.worker({
              encrypted: encrypted,
              event: event
            });

          case 4:
            _ref2 = _context.sent;
            message = _ref2.message;
            payload = JSON.parse(message);
            return _context.abrupt("return", payload);

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function decryptPayload(_x) {
    return _ref.apply(this, arguments);
  };
}();
/**
 * Encrypt payload to be transmitted between web app and extension.
 *
 * @param {object} payload
 * @param {string} [publicKey] Not providing a key returns null.
 *
 * @returns {string} Encrypted data or null.
 */


var encryptPayload =
/*#__PURE__*/
function () {
  var _ref3 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee2(payload, publicKey) {
    var encrypted, event, message, _ref4;

    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            checkLinkExists();
            encrypted = null;

            if (!publicKey) {
              _context2.next = 9;
              break;
            }

            event = state.encryptEvent;
            message = JSON.stringify(payload);
            _context2.next = 7;
            return state.worker({
              event: event,
              message: message,
              publicKey: publicKey
            });

          case 7:
            _ref4 = _context2.sent;
            encrypted = _ref4.encrypted;

          case 9:
            return _context2.abrupt("return", encrypted);

          case 10:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));

  return function encryptPayload(_x2, _x3) {
    return _ref3.apply(this, arguments);
  };
}();
/**
 * Attempts to detect an extension event and return the original payload.
 *
 * @param {object} message Created message.
 * @param {function} check Message validator.
 *
 * @returns {any} Payload data if successful or null.
 */


var extractPayload =
/*#__PURE__*/
function () {
  var _ref5 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee3(message, check) {
    var payload, encrypted;
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            if (!looksLikeValidMessage(message, check)) {
              _context3.next = 9;
              break;
            }

            payload = message.payload;
            encrypted = typeof payload === 'string';

            if (!encrypted) {
              _context3.next = 7;
              break;
            }

            _context3.next = 6;
            return decryptPayload(payload);

          case 6:
            payload = _context3.sent;

          case 7:
            logPayload(payload, message, true);
            return _context3.abrupt("return", payload);

          case 9:
            return _context3.abrupt("return", null);

          case 10:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, this);
  }));

  return function extractPayload(_x4, _x5) {
    return _ref5.apply(this, arguments);
  };
}();
/**
 * @param {object} payload
 * @param {object|string} message
 *
 * @returns {any}
 */


var getLogData = function getLogData(payload, message) {
  if (state.logger.plaintext) {
    return payload.data;
  }

  payload = message.payload;

  if (typeof payload === 'string' || payload === null) {
    return payload;
  }

  return payload.data;
};
/**
 * @param {boolean} [incoming]
 * @param {object|string} message
 *
 * @returns {string}
 */


var getLogEmoji = function getLogEmoji(incoming, message) {
  var emoji = '';

  if (incoming) {
    emoji = state.target === SRC_WEB && message.id ? '👌' : '📩';
  } else {
    emoji = state.target === SRC_WEB ? '☁️' : '↩️️';
  }

  return emoji;
};
/**
 * @returns {string}
 */


var getMessageIncomingSource = function getMessageIncomingSource() {
  checkValidTarget();
  return state.target === SRC_EXT ? SRC_WEB : SRC_EXT;
};
/**
 * @returns {string}
 */


var getMessageOutgoingSource = function getMessageOutgoingSource() {
  checkValidTarget();
  return state.target === SRC_EXT ? SRC_EXT : SRC_WEB;
};
/**
 * @param {string} emoji
 * @param {string} [event='']
 * @param {string} [contents='']
 */


var logLine = function logLine(emoji) {
  var event = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var contents = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  if (!state.logger.enabled) return;
  var source = (0, _helpers.capitalize)(getMessageIncomingSource());
};
/**
 * @param {object} payload
 * @param {object|string} message
 * @param {boolean} [incoming]
 */


var logPayload = function logPayload(payload, message, incoming) {
  var event = payload !== null ? payload.event : _constants.WEL_STATUS;
  if (incoming && event === _constants.WEL_STATUS) return;
  var data = getLogData(payload, message);
  var emoji = getLogEmoji(incoming, message);
  var contents = data && Object.keys(data).length ? data : '';
  logLine(emoji, event, contents);
};
/**
 * @param {object} msg Created message.
 * @param {function} check Message validator.
 *
 * @returns {boolean}
 */


var looksLikeValidMessage = function looksLikeValidMessage(msg, check) {
  if (msg && msg.source === getMessageIncomingSource() && typeof check === 'function') {
    return check(msg);
  }

  return false;
};
/**
 * This method needs to be called on init to define variables.
 *
 * @param {object} [args={}]
 * @property {string} decryptEvent Decrypt event constant for crypto worker.
 * @property {string} encryptEvent Encrypt event constant for crypto worker.
 * @property {function} getter Crypto worker getter function.
 * @property {object|boolean} [logger]
 * @property {boolean} [enabled]
 * @property {boolean} [plaintext]
 * @property {string} target Host environment. One of `extension` or `web`.
 */


var createWebExtensionLink = function createWebExtensionLink() {
  var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  checkDuplicateInit();

  var getter = args.getter,
      _logger = args.logger,
      nextState = _objectWithoutProperties(args, ["getter", "logger"]);

  var logger = constructLoggerOptions(_logger);
  var worker = getter('crypto');
  setState(_objectSpread({}, nextState, {
    logger: logger,
    worker: worker
  }));
};
/**
 * @param {boolean} connected
 */


exports.createWebExtensionLink = createWebExtensionLink;

var logConnectEvent = function logConnectEvent(connected) {
  var emoji = connected ? '✅' : '🛑';
  logLine(emoji);
};
/**
 * Create a new message to be transmitted between web app and extension.
 *
 * @param {object} args
 * @property {string} [id]
 * @property {object} payload
 * @property {string} publicKey
 *
 * @returns {object}
 * @property {string} [id] Depends on `args.id`
 * @property {string} payload
 * @property {string} source
 */


exports.logConnectEvent = logConnectEvent;

var signMessage =
/*#__PURE__*/
function () {
  var _ref6 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee4() {
    var args,
        id,
        payload,
        publicKey,
        encrypt,
        _payload,
        source,
        message,
        _args4 = arguments;

    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            args = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : {};
            id = args.id, payload = args.payload, publicKey = args.publicKey;
            encrypt = !PLAINTEXT_EVENTS.includes(payload.event);

            if (!encrypt) {
              _context4.next = 9;
              break;
            }

            _context4.next = 6;
            return encryptPayload(payload, publicKey);

          case 6:
            _context4.t0 = _context4.sent;
            _context4.next = 10;
            break;

          case 9:
            _context4.t0 = payload;

          case 10:
            _payload = _context4.t0;
            source = getMessageOutgoingSource();
            message = {
              payload: _payload,
              source: source
            };
            if (id) message.id = id;
            logPayload(payload, message, false);
            return _context4.abrupt("return", message);

          case 16:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, this);
  }));

  return function signMessage() {
    return _ref6.apply(this, arguments);
  };
}();
/**
 * @param {object} data
 * @param {function} check
 * @param {function} [callback]
 */


exports.signMessage = signMessage;

var verifyMessage =
/*#__PURE__*/
function () {
  var _ref7 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee5(data, check, callback) {
    var message, payload;
    return regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.prev = 0;
            message = (0, _helpers.safeJSONParse)(data);
            _context5.next = 4;
            return extractPayload(message, check);

          case 4:
            payload = _context5.sent;
            if (payload && typeof callback === 'function') callback(payload, message);
            _context5.next = 11;
            break;

          case 8:
            _context5.prev = 8;
            _context5.t0 = _context5["catch"](0);
            if (typeof callback === 'function') callback(null, null, _context5.t0);

          case 11:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, this, [[0, 8]]);
  }));

  return function verifyMessage(_x6, _x7, _x8) {
    return _ref7.apply(this, arguments);
  };
}();

exports.verifyMessage = verifyMessage;